<div class="recommended-challenges" *ngIf="challenges?.length">
  <div class="d-flex align-items-start border-bottom py-4 recommended-challenge-item"
    *ngFor="let challenge of challenges; trackBy: trackByUuid">
    <div class="flex-grow-1 overflow-hidden">
      <a class="fw-bolder fs-6 text-dark text-hover-primary d-block text-truncate"
        [routerLink]="['/challenges', challenge.uuid, 'details']" [ngbTooltip]="challenge.title">
        {{ challenge.title }}
      </a>
      <div class="text-gray-600 fs-7 mt-1" *ngIf="challenge.corporateName">
        {{ challenge.corporateName }}
      </div>
      <div class="text-gray-700 fs-7 mt-1 recommendation-reason" *ngIf="challenge.reasonLine">
        {{ challenge.reasonLine }}
      </div>
    </div>
    <span class="badge badge-light-warning fs-8 ms-3 closing-soon-chip" *ngIf="challenge.closingChip">
      {{ challenge.closingChip }}
    </span>
  </div>
</div>

<div class="text-center mt-10 mb-10 recommended-challenges-empty" *ngIf="loaded && !loading && !challenges?.length">
  <i class="bi bi-exclamation-circle" style="font-size: 60px;">
  </i><br><br>
  <span class="fs-5 text-center my-4 text-gray-500">
    No matching challenges right now. Complete your sectors to get better matches.
  </span>
</div>
